// extracted by mini-css-extract-plugin
export var arrow = "_3q-6";
export var changeItem = "_3q-3";
export var changesHeader = "_3q-1";
export var changesList = "_3q-2";
export var container = "_3q-0";
export var pathLabel = "_3q-4";
export var value = "_3q-7";
export var valuesContainer = "_3q-5";